import { sampleGoals } from './goals';

export const getSampleGoalsTotal = (() => {
    const memoizedTotal = sampleGoals.reduce((acc, goal) => {
        const balance = goal.financialEntities.reduce((acc, fe) => {
            return acc + (fe.latestSnapshot ? fe.latestSnapshot.balance : 0);
        }, 0);

        return acc + balance;
    }, 0);

    return () => memoizedTotal;
})();
